import { Component, Inject } from '@angular/core'
import { MapService } from 'src/app/core/services/map.service'
import { Observable, Subject, debounceTime, interval, takeUntil } from 'rxjs'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { AppPaths } from 'src/app/app-routing.module'
import { Layers } from 'src/app/shared/layers-config/layers'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { getMetricFromMap } from '../enums/obstacle-metrics.enum'
import {
  provider1AccidentLayerProvider,
  provider1ConstructioSiteLayerProvider,
  provider1BDVLayerProvider,
  provider2ConstructioSiteLayerProvider,
  provider2AccidentLayerProvider,
  provider2BDVLayerProvider,
  provider3ConstructioSiteLayerProvider,
  provider3BDVLayerProvider,
  provider3AccidentLayerProvider,
  provider4BDVLayerProvider,
  provider4AccidentLayerProvider,
  provider6AccidentLayerProvider,
  provider6BDVLayerProvider,
  provider7AccidentLayerProvider,
  provider7BDVLayerProvider,
  provider8AccidentLayerProvider,
  provider8BDVLayerProvider,
  provider8WdwLayerProvider,
  provider8SvLayerProvider,
  provider8CsLayerProvider,
  Provider9CsLayerProvider,
  Provider9SvLayerProvider,
} from 'src/app/shared/providers/layer-service-provider'
import { LayerRawEventsService } from 'src/app/shared/layers/layer-raw-events.service'
import { LayerCustomerWarningService } from 'src/app/shared/layers/layer-customer-warning.service'
import { DataCustomerWarningService } from 'src/app/shared/services/data-customer-warning.service'
import { Permissions } from 'src/app/core/enums/permissions.enum'
import { obstacleWarningLayerProvider } from 'src/app/shared/providers/warning-layers-provider'
import { DataProviderInfoService } from 'src/app/shared/services/data-provider-info.service'
import { ProviderInfo } from '../model/provider-info.model'

@Component({
  selector: 'app-obstacle-page',
  templateUrl: './obstacle-page.component.html',
  standalone: false,
  providers: [
    LayerCustomerWarningService,
    DataCustomerWarningService,
    DataProviderInfoService,
    { provide: 'metrics', useValue: getMetricFromMap },
    provider1AccidentLayerProvider,
    provider1BDVLayerProvider,
    provider1ConstructioSiteLayerProvider,
    provider2AccidentLayerProvider,
    provider2BDVLayerProvider,
    provider2ConstructioSiteLayerProvider,
    provider3AccidentLayerProvider,
    provider3BDVLayerProvider,
    provider3ConstructioSiteLayerProvider,
    provider4AccidentLayerProvider,
    provider4BDVLayerProvider,
    provider6AccidentLayerProvider,
    provider6BDVLayerProvider,
    provider7AccidentLayerProvider,
    provider7BDVLayerProvider,
    provider8AccidentLayerProvider,
    provider8BDVLayerProvider,
    provider8WdwLayerProvider,
    provider8SvLayerProvider,
    provider8CsLayerProvider,
    Provider9CsLayerProvider,
    Provider9SvLayerProvider,
    obstacleWarningLayerProvider,
  ],
})
export class ObstaclePageComponent {
  public Permissions = Permissions
  private stopTimer = new Subject<void>()
  public isObstacleLayerVisibile = false
  public isProvider4AccidentLayerVisible = false
  public isProvider4BdvLayerVisible = false
  public isProvider1BdvLayerVisible = false
  public isProvider1AccidentLayerVisible = false
  public isBdvWarningLayerVisible = false
  public isProvider1ConstructionSiteLayerVisible = false
  public isProvider2AccidentLayerVisible = false
  public isProvider2BdvLayerVisible = false
  public isProvider2ConstructionSiteLayerVisible = false
  public isProvider3AccidentLayerVisible = false
  public isProvider3BdvLayerVisible = false
  public isProvider3ConstructionSiteLayerVisible = false
  public isProvider6AccidentLayerVisible = false
  public isProvider6BdvLayerVisible = false
  public isProvider7AccidentLayerVisible = false
  public isProvider7BdvLayerVisible = false
  public isProvider8AccidentLayerVisible = false
  public isProvider8BdvLayerVisible = false
  public isProvider8WdwLayerVisible = false
  public isProvider8SvLayerVisible = false
  public isProvider8CsLayerVisible = false
  public isProvider9CsLayerVisible = false
  public isProvider9SvLayerVisible = false
  public isAccidentWarningLayerVisible = false
  public isConstructionSiteWarningLayerVisible = false
  public isInLiveMode = false
  public autoRefreshIntervalInMs = 0
  public displayRefreshInterval = 0
  public layerIds = Layers
  public currentTimestamp: Date | undefined
  public currentTimespan: number | undefined
  public isHistoryVisible = false
  public isLegendVisible = false
  public ProviderInfo$!: Observable<ProviderInfo>

  constructor(
    private mapService: MapService,
    public appState: AppStateService,
    @Inject('provider1AccidentLayer') public provider1AccidentLayerService: LayerRawEventsService,
    @Inject('provider1BDVLayer') public provider1BDVLayerService: LayerRawEventsService,
    @Inject('provider1ConstructionSiteLayer')
    public provider1ConstructioSiteLayerService: LayerRawEventsService,
    @Inject('provider2AccidentLayer') public provider2AccidentLayerService: LayerRawEventsService,
    @Inject('provider2BDVLayer') public provider2BDVLayerService: LayerRawEventsService,
    @Inject('provider2ConstructionSiteLayer')
    public provider2ConstructioSiteLayerService: LayerRawEventsService,
    @Inject('provider3AccidentLayer') public provider3AccidentLayerService: LayerRawEventsService,
    @Inject('provider3BDVLayer') public provider3BDVLayerService: LayerRawEventsService,
    @Inject('provider3ConstructionSiteLayer')
    public provider3ConstructioSiteLayerService: LayerRawEventsService,
    @Inject('provider6AccidentLayer') public provider6AccidentLayerService: LayerRawEventsService,
    @Inject('provider6BDVLayer') public provider6BDVLayerService: LayerRawEventsService,
    @Inject('provider7AccidentLayer')
    public provider7AccidentLayerService: LayerRawEventsService,
    @Inject('provider7BDVLayer') public provider7BDVLayerService: LayerRawEventsService,
    @Inject('provider8AccidentLayer') public provider8AccidentLayerService: LayerRawEventsService,
    @Inject('provider8BDVLayer') public provider8BDVLayerService: LayerRawEventsService,
    @Inject('provider8WdwLayer') public provider8WdwLayerService: LayerRawEventsService,
    @Inject('provider8SvLayer') public provider8SvLayerService: LayerRawEventsService,
    @Inject('provider8CsLayer') public provider8CsLayerService: LayerRawEventsService,
    @Inject('Provider9CsLayer') public Provider9CsLayerService: LayerRawEventsService,
    @Inject('Provider9SvLayer') public Provider9SvLayerService: LayerRawEventsService,
    @Inject('provider4BDVLayer') public provider4BDVLayerService: LayerRawEventsService,
    @Inject('provider4AccidentLayer') public provider4AccidentLayerService: LayerRawEventsService,
    @Inject('obstacleWarningLayer')
    public obstacleWarningLayerService: LayerCustomerWarningService,
    private dataProviderInfoService: DataProviderInfoService,
  ) {
    this.mapService.activateGeoLocationSearch()
    this.mapService.setPosition(
      this.appState.getState().lat,
      this.appState.getState().lon,
      this.appState.getState().zoom,
    )
    if (this.appState.getState().historyEnabled) {
      this.isHistoryVisible = true
    }
    this.updateQueryParameters()
    this.mapService.mapViewChanged
      .pipe(takeUntilDestroyed())
      .pipe(debounceTime(500))
      .subscribe(() => {
        this.updateQueryParameters()
      })

    this.evaluateQueryParameters()
    this.appState.stateChanged.pipe(takeUntilDestroyed()).subscribe(() => {
      this.evaluateQueryParameters()
    })
  }

  async ngOnInit() {
    this.ProviderInfo$ = await this.dataProviderInfoService.loadProviderInfo()
  }

  ngOnDestroy() {
    this.mapService.deactivateGeoLocationSearch()
    this.stopTimer.next()
    this.stopTimer.complete()
  }

  setLiveModeRefreshInterval(seconds: number) {
    this.autoRefreshIntervalInMs = seconds * 1000
    this.displayRefreshInterval = seconds
    this.stopLiveMode()
    if (this.autoRefreshIntervalInMs > 0) {
      this.startLiveMode()
    }
  }

  startLiveMode() {
    this.isInLiveMode = true
    this.stopTimer = new Subject<void>()
    interval(this.autoRefreshIntervalInMs)
      .pipe(takeUntil(this.stopTimer))
      .subscribe(() => {
        this.provider1AccidentLayerService.reload()
        this.provider1BDVLayerService.reload()
        this.provider1ConstructioSiteLayerService.reload()
        this.provider2AccidentLayerService.reload()
        this.provider2BDVLayerService.reload()
        this.provider2ConstructioSiteLayerService.reload()
        this.provider3AccidentLayerService.reload()
        this.provider3BDVLayerService.reload()
        this.provider3ConstructioSiteLayerService.reload()
        this.provider6AccidentLayerService.reload()
        this.provider6BDVLayerService.reload()
        this.provider7AccidentLayerService.reload()
        this.provider7BDVLayerService.reload()
        this.provider8AccidentLayerService.reload()
        this.provider8BDVLayerService.reload()
        this.provider8WdwLayerService.reload()
        this.provider8SvLayerService.reload()
        this.provider8CsLayerService.reload()
        this.Provider9CsLayerService.reload()
        this.Provider9SvLayerService.reload()
        this.provider4AccidentLayerService.reload()
        this.provider4BDVLayerService.reload()
        this.obstacleWarningLayerService.reload()
      })
  }

  stopLiveMode() {
    this.isInLiveMode = false
    this.stopTimer.next()
  }

  toggleHistory = () => {
    if (!this.isHistoryVisible) {
      this.setLiveModeRefreshInterval(0)
    }
    this.isHistoryVisible = !this.isHistoryVisible
    this.updateQueryParameters()
  }

  toggleLegend = () => {
    this.isLegendVisible = !this.isLegendVisible
  }

  handleHistoryClosed = () => {
    this.setLiveModeRefreshInterval(0)
    this.isHistoryVisible = false
    this.updateQueryParameters()
  }

  evaluateQueryParameters() {
    if (this.appState.getState().historyEnabled) {
      this.isHistoryVisible = true
    }

    const layers = this.appState.selectLayers()

    if (layers.some((layer) => layer === Layers.Provider1Accidents.name)) {
      this.isProvider1AccidentLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider1ConstructionSites.name)) {
      this.isProvider1ConstructionSiteLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider1Bdv.name)) {
      this.isProvider1BdvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider2Accidents.name)) {
      this.isProvider2AccidentLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider2ConstructionSites.name)) {
      this.isProvider2ConstructionSiteLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider2Bdv.name)) {
      this.isProvider2BdvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider3Accidents.name)) {
      this.isProvider3AccidentLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider3ConstructionSites.name)) {
      this.isProvider3ConstructionSiteLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider3Bdv.name)) {
      this.isProvider3BdvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider4Accidents.name)) {
      this.isProvider4AccidentLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider4Bdv.name)) {
      this.isProvider4BdvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider6Accidents.name)) {
      this.isProvider6AccidentLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider6Bdv.name)) {
      this.isProvider6BdvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider7Accidents.name)) {
      this.isProvider7AccidentLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider7Bdv.name)) {
      this.isProvider7BdvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider8Accidents.name)) {
      this.isProvider8AccidentLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider8Bdv.name)) {
      this.isProvider8BdvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider8Wdw.name)) {
      this.isProvider8WdwLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider8Sv.name)) {
      this.isProvider8SvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider8Cs.name)) {
      this.isProvider8CsLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider9Cs.name)) {
      this.isProvider9CsLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.Provider9Sv.name)) {
      this.isProvider9SvLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.BDVWarning.name)) {
      this.isBdvWarningLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.VAWarning.name)) {
      this.isAccidentWarningLayerVisible = true
    }
    if (layers.some((layer) => layer === Layers.CSWarning.name)) {
      this.isConstructionSiteWarningLayerVisible = true
    }
  }

  updateQueryParameters() {
    this.appState.setState(AppPaths.Obstacle, {
      lat: this.mapService.map.getCenter().lat,
      lon: this.mapService.map.getCenter().lng,
      zoom: this.mapService.map.getZoom(),
      historyEnabled: this.isHistoryVisible ? true : undefined,
      filter: 'rcs-data',
    })
  }
}
